/**
* @file 营销管理-轮播广告
* */
<template>
  <div id="carousel">
    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" 
      :addText="$refs.customTable && $refs.customTable.table.total >= 10 ? '' : '新增广告'" @addFn="visibleDrawer = true"
      :paging="false">
      <div class="search-top-left" slot="search-top-left">当前轮播速度 <span class="second">{{ time }}秒</span>
        <el-button class="set" type="text" @click="setClick">设置</el-button>
      </div>
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="160px">
          <div slot-scope="{row, $index}" class="custom-action">
            <el-tooltip content="编辑" placement="top">
              <i class="iconfont icon-compile" @click="advertisingClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <i class="iconfont icon-delete" @click="removeClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="下移" placement="top" v-if="$index !== $refs.customTable.table.total - 1">
              <i class="iconfont icon-move-down" @click="moveClick(row, 'down', $index)"></i>
            </el-tooltip>
            <el-tooltip content="上移" placement="top" v-if="$index !== 0">
              <i class="iconfont icon-move-up" @click="moveClick(row, 'up', $index)"></i>
            </el-tooltip>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop === 'coverImg'">
          <img :src="mixinQiniuImg(row.coverImg, 343, 126)" style="width: 171.5px; height: 63px;" alt="">
        </template>
        <template v-else-if="item.prop === 'status'">
          <div class="custom-switch" @click="switchClick(row)">
            <el-switch disabled v-model="row.status" :active-value="1" :inactive-value="2"></el-switch>
          </div>
        </template>
        <template v-else-if="item.prop === 'jumpTo'">
          <div v-if="row.jumpType == 6">营销活动页面</div>
          <div v-else-if="row.jumpType == 5">{{ row.jumpTo ? JSON.parse(row.jumpTo).name : '-' }}</div>
          <div v-else>{{row.jumpTo || '-'}}</div>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>
    </custom-table>

    <!--设置轮播速度弹框-->
    <el-dialog title="轮播速度" :visible.sync="visible" width="400px" :close-on-click-modal="false">
      <el-form label-position="left" :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="当前轮播速度" prop="time">
          <el-input v-model="form.time" maxlength="2">
            <template slot="append">秒</template>
          </el-input>
        </el-form-item>
      </el-form>
      <p class="util-remark">说明：用户端小程序Banner的图片切换速度</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="postBannerTime">确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer :visible.sync="visibleDrawer" :before-close="advertisingClose">
      <carouselForm :visible.sync="visibleDrawer" :id="id" @advertisingClose="advertisingClose" />
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "carousel",
  components: {
    carouselForm: () => import("./carouselForm")
  },
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/banner'
      },
      // 表头
      columns: [
        { prop: 'sort', label: '展示顺序', width: 70 },
        { prop: 'coverImg', label: '封面图片' },
        { prop: 'remark', label: '备注信息' },
        { prop: 'created', label: '创建时间' },
        { prop: 'status', label: '是否启用' },
        { prop: 'jumpTo', label: '跳转页面' }
      ],
      // 设置轮播速度的弹框
      visible: false,
      // 显示的时间
      time: '',
      // 设置轮播速度对象
      form: {
        time: 1
      },
      // 校验规则
      rules: {
        time: [
          { required: true, message: '请输入轮播速度' },
          { pattern: /^[1-9]\d?$/, message: '请输入正确的数字' }
        ]
      },

      visibleDrawer: false,
      id: null
    }
  },
  created() {
    this.getBannerTime()
  },
  methods: {
    advertisingClick(row) {
      this.visibleDrawer = true;
      this.id = row.id;
    },
    advertisingClose() {
      this.visibleDrawer = false;
      this.id = null;
      this.$refs.customTable.listFn();
    },

    advertisingAdd() {
      this.visibleDrawer = true;
    },

    /* 设置轮播速度 */
    setClick() {
      this.visible = true
    },

    /* 轮播速度查询 */
    async getBannerTime() {
      let url = '/api/v1/manage/banner/config';
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.form = data.data || {}
        this.time = data.data.time
      }
    },

    /* 轮播速度保存 */
    postBannerTime() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let url = '/api/v1/manage/banner/config';
          let data = await this.$axios.post(url, this.form);
          if (data && data.code === 1) {
            this.visible = false;
            this.$message.success('设置成功！');
            this.getBannerTime()
          }
        } else {
          this.$message.warning('请检查表单数据是否输入正确！');
          return false;
        }
      });
    },

    /* 开关 */
    switchClick(row) {
      this.$confirm(`确认要${row.status === 1 ? '关闭' : '开启'}吗?`, '提示').then(async () => {
        let status = row.status === 1 ? 2 : 1
        this.putFn(row, status)
      })
    },

    /* 接口请求-编辑 */
    async putFn(row, status) {
      let url = '/api/v1/manage/banner';
      let params = Object.assign(row, { status });
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success(`已${row.status == 1 ? '开启' : '关闭'}`);
        this.$refs.customTable.listFn();
      }
    },

    /* 接口调用-排序 */
    async postSort(bannerSort) {
      let url = '/api/v1/manage/banner/sort';
      let params = {
        bannerSort: bannerSort
      }
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success('操作成功！');
        this.$refs.customTable.listFn();
      }
    },

    /* 下移 */
    moveClick(row, type) {
      let index = this.$refs.customTable.table.content.findIndex(value => value.id === row.id);

      if (type === 'up') {
        this.$refs.customTable.table.content[index].sort -= 1;
        this.$refs.customTable.table.content[index - 1].sort += 1;
      } else if (type === 'down') {
        this.$refs.customTable.table.content[index].sort += 1;
        this.$refs.customTable.table.content[index + 1].sort -= 1;
      }
      let bannerSort = JSON.stringify(this.$refs.customTable.table.content);
      this.postSort(bannerSort)
    },

    /* 列表-删除 */
    removeClick(row) {
      let text = row.status === 1 ? '删除后广告将不可见，确认删除吗?' : '确认要删除该广告吗?';
      this.$confirm(text, '删除提示').then(async () => {
        let url = '/api/v1/manage/banner';
        let params = {
          id: row.id
        }
        let data = await this.$axios.delete(url, params);
        if (data && data.code === 1) {
          this.$message.success('删除成功');
          this.$refs.customTable.listFn()
        }
      })
    }
  }
}
</script>

<style lang="less">
#carousel {
  .search-top-left {
    font-weight: 600;

    .second {
      color: #999;
    }

    .set {
      margin-left: 10px;
    }
  }

  .el-input {
    width: auto;
  }

  .el-table .cell.el-tooltip {
    display: flex;
  }
}
</style>
